export const InfoDialogIcon: React.FC<{ className?: string }> = ({ className }) => {
	return (
		<svg
			className={className}
			width="26"
			height="26"
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 7C11.7167 7 11.4792 6.90417 11.2875 6.7125C11.0958 6.52083 11 6.28333 11 6C11 5.71667 11.0958 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6C13 6.28333 12.9042 6.52083 12.7125 6.7125C12.5208 6.90417 12.2833 7 12 7ZM13 15H11V9H13V15ZM22 22V4C22 3.45 21.8042 2.97917 21.4125 2.5875C21.0208 2.19583 20.55 2 20 2H4C3.45 2 2.97917 2.19583 2.5875 2.5875C2.19583 2.97917 2 3.45 2 4V16C2 16.55 2.19583 17.0208 2.5875 17.4125C2.97917 17.8042 3.45 18 4 18H18L22 22ZM18.85 16H4V4H20V17.125L18.85 16Z"
				fill="#637381"
			/>
		</svg>
	);
};
